import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import {
  ButtonStyled,
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
  YellowSticker,
} from "./styles";

export default function FreeHeader(props) {
  const [solutions, setSolutions] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    // const response = await dispatch(fetchHiredlyXContent(query));

    const response = content_my;

    const { secondCardSection } = response || {};
    setSolutions(secondCardSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Get Started — Post for Free";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerInfoDialog() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "post_for_free_header",
    });
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <CardContainer>
        <YellowSticker>
          <b>Free Job Posts</b>
          <p>
            <i>3+3</i> per month
          </p>
        </YellowSticker>
        <CardListContainer>
          <CardTextContainer>
            <CardText
              type={"title"}
              dangerouslySetInnerHTML={{ __html: solutions?.title }}
            ></CardText>
            <CardText
              type={"desc"}
              dangerouslySetInnerHTML={{ __html: solutions?.subtitle }}
            ></CardText>

            <ButtonStyled onClick={triggerInfoDialog}>{buttonCTA}</ButtonStyled>
          </CardTextContainer>

          <CardImage src={solutions?.coverImage?.data?.attributes?.url} />
        </CardListContainer>
      </CardContainer>
    </GridContainerStyled>
  );
}
